import React from 'react';
import {FormattedMessage} from 'react-intl';
import {useTransfersByAgentContext} from '../contexts/TransfersByAgentContext';
import moment from 'moment';
import styles from './styles.module.scss';

export function Warning() {
  const {notifications, agentId} = useTransfersByAgentContext();
  const {
    discounts,
    form101FileExists,
    taxAdjustmentFileExists,
    otherIncomeExists,
    affiliate,
  } = notifications;
  const discountsNames = discounts && Array.isArray(discounts)
    ? discounts.map(item => {
      if (item?.invited?.username) {
        return item.invited.username;
      } else if (item?.invited?.name) {
        return item.invited.name;
      } else {
        return '';
      }
    }).filter(Boolean).join(', ')
    : '';

  return (
    <div className={styles.warning}>
      <div className={styles.container}>
        <span>⚠️</span>
        {discounts.length > 0 && agentId && (
          <div className={styles.message}>
            <FormattedMessage
              id={'TransfersList.discountAlert'}
              defaultMessage={'The agent was given a benefit for inviting the following users: {names}'}
              values={{names: discountsNames}}
            />
          </div>
        )}
        <div className={styles.message}>
          {form101FileExists
            ? (
              <FormattedMessage
                id={'TransfersList.form101FileAlert.filled'}
                defaultMessage={'The agent filled form 101 for {year}'}
                values={{year: moment().year()}}
              />
            )
            : (
              <FormattedMessage
                id={'TransfersList.form101FileAlert.didnt.filled'}
                defaultMessage={'The agent didn\'t filled form 101 for {year}'}
                values={{year: moment().year()}}
              />
            )}
        </div>
        <div className={styles.message}>
          {taxAdjustmentFileExists
            ? (
              <FormattedMessage
                id={'TransfersList.taxAdjustmentAlert.filled'}
                defaultMessage={'The agent uploaded tax adjustment filed'}
                values={{year: moment().year()}}
              />
            )
            : (
              <FormattedMessage
                id={'TransfersList.taxAdjustmentAlert.didnt.filled'}
                defaultMessage={'The agent uploaded tax adjustment did\'t filed'}
                values={{year: moment().year()}}
              />
            )}
        </div>
        {otherIncomeExists && agentId && (
          <div className={styles.message}>
            <FormattedMessage
              id={'TransfersList.isOtherIncomeExists.true'}
              defaultMessage={'The other income exists'}
            />
          </div>
        )}
        {affiliate && agentId && (
          <div className={styles.message}>
            <FormattedMessage
              id={'TransfersList.affiliateAlert'}
              defaultMessage={'This agent is registered through - {names}'}
              values={{
                names: affiliate
              }}
            />
          </div>
        )}
      </div>
    </div>
  );
}
